// SPDX-License-Identifier: EUPL-1.2
/*
 * Copyright (c) 2025, European Commission. Licensed under the EUPL-1.2
 * Authors:
 *   Pierluigi Spedicato
 *   Maurizio Funaro
 */

import { configureStore } from '@reduxjs/toolkit';
import { commentsReducer } from './comments/comments-slice';
import { commentsSliceName } from './comments/comments-slice.name';
import { configReducer } from './config/config-slice';
import { configSliceName } from './config/config-slice.name';
import { cookieReducer } from './cookie/cookie-slice';
import { cookieSliceName } from './cookie/cookie-slice.name';
import { mainReducer } from './main/main-slice';
import { mainSliceName } from './main/main-slice.name';

const store = configureStore({
	// ...reduxDevToolsConfig,
	reducer: {
		[mainSliceName]: mainReducer,
		[commentsSliceName]: commentsReducer,
		[cookieSliceName]: cookieReducer,
		[configSliceName]: configReducer
	}
});

export { store };

export type AppStore = typeof store;

export type AppDispatch = AppStore['dispatch'];
